import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Col } from 'react-bootstrap';
import { Label } from 'ypf-pas-general-ui-components';
import { BsCalendar } from 'react-icons/bs';

const DatesColumn = ({ sm, datesList }) => {
  const isLastElement = (currentIndex, array) => array.length - 1 === currentIndex;

  return (
    <Col className="d-flex flex-column justify-content-evenly border-start p-0" sm={sm}>
      {datesList?.map((date, index) => (
        <Fragment key={date.label}>
          <div className="d-flex align-items-center">
            <Label
              label={date.label}
              value={
                <div className="d-flex align-items-center">
                  {date.icon || <BsCalendar className="me-2" size={18} />}
                  <div>{date.value}</div>
                </div>
              }
            />
          </div>
          {!isLastElement(index, datesList) && <hr className="my-0" />}
        </Fragment>
      ))}
    </Col>
  );
};

export default DatesColumn;

DatesColumn.propTypes = {
  sm: PropTypes.number,
  datesList: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.string,
      icon: PropTypes.node // Por defecto se muestra el BsCalendar
    })
  )
};

DatesColumn.defaultProps = {
  sm: 3,
  datesList: []
};
